export function FreshdeskLink({
  articleID,
  linkText,
  className,
}: {
  articleID: number;
  linkText: string;
  className?: string;
}) {
  return (
    <a
      className={className}
      href={`https://workoptima.freshdesk.com/support/solutions/articles/${articleID}`}
      onClick={(e) => {
        e.preventDefault();
        FreshworksWidget('open', 'article', {
          id: articleID,
        });
      }}
    >
      {linkText}
    </a>
  );
}
